import InputField from "../../../../reusable-components/TNInputField";
import { addNotesModalFields } from "./constants";
import styles from "./NotesTableForm.module.scss";

const NotesTableForm = () => {
  return (
    <>
      <div className={styles.parentContainer}>
        {addNotesModalFields.map((field) => (
          <InputField
            name={field.name}
            label={field.label}
            type={field.type}
            placeholder={field.placeholder}
            requiredField={field.required}
            style={{
              width: "50%",
            }}
            maxLength={field?.maxLenght}
            showCount={field?.showCount}
          />
        ))}
      </div>
    </>
  );
};

export default NotesTableForm;
